import styled from 'styled-components';

export const FeedSectionArea = styled.section`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
`;

